export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false
  }

  const userAgent = navigator.userAgent.toLowerCase()
  const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i
  const isMobileByUserAgent = mobileRegex.test(userAgent)

  // const isMobileByScreen = window.innerWidth <= 768
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0

  return isMobileByUserAgent || isTouchDevice || false
}

export const isIOSDevice = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false
  }

  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /iphone|ipad|ipod/i.test(userAgent)

  const isMacWithTouch = /macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1

  return isIOS || isMacWithTouch
}

export const setViewportHeight = (): void => {
  if (typeof window === "undefined") return

  const setVH = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)

    if (CSS.supports("height", "100dvh")) {
      document.documentElement.style.setProperty("--dvh", `${vh}px`)
    }
  }

  setVH()

  window.addEventListener("resize", setVH)
  window.addEventListener("orientationchange", setVH)
}
